import { AccordionDesignTokens } from '@primeuix/themes/types/accordion';

export const accordion: AccordionDesignTokens = {
  colorScheme: {
    dark: {
      header: {
        color: '{text.100}',
        background: '{surface.500}',
        activeBackground: '{surface.500}',
        activeHoverBackground: '{surface.500}',
        activeColor: '{text.100}',
        hoverBackground: '{surface.500}',
        hoverColor: '{text.100}',
      },
      content: {
        background: '{surface.500}',
      },
      panel: {
        borderWidth: '0 0 2px 0',
      },
    },
  },
};
